import { Image as ChakraImage, ImageProps } from '@chakra-ui/react';

// wrapper for Image, will use later on for optimization, like lazy loading .etc
export function Image(props: ImageProps) {
  return <ChakraImage {...props} />;
}
